module.exports = "img/upload-big.51a2e5d.png";